import React, { useCallback, useRef, useState } from 'react';
import _debounce from 'lodash-es/debounce';
import Textarea from '@teetsh/app/src/components/Form/Textarea';
import tw from 'twin.macro';
import { LivretEleve } from '@teetsh/app/src/containers/Livrets/types/livret';
import clsx from 'clsx';
import { Competences } from './Competences';
import FormGroup from '@teetsh/app/src/components/Form/FormGroup';
import { useTranslation } from 'react-i18next';
import _isEmpty from 'lodash-es/isEmpty';

interface Props {
  livretEleve: LivretEleve;
  onChange?: (p: LivretEleve) => void;
  readonly?: boolean;
  className?: string;
  livretEvalId: string;
}

export function CompetencesNumeriqueList(props: Props) {
  const { onChange, readonly, className, livretEvalId } = props;
  const [value, setValue] = useState<LivretEleve>(props.livretEleve);
  const { t } = useTranslation(['carnet', 'common']);
  const debouncedSave = useCallback(
    _debounce(nextValue => onChange && onChange(nextValue), 500),
    [onChange, props.livretEleve],
  );
  const handleChange = nextValue => {
    setValue(nextValue);
    debouncedSave(nextValue);
  };
  const textareaRef = useRef();
  return (
    <div className={clsx(className)}>
      {(value.competencesNumerique || []).length > 0 && (
        <div css={[tw`text-xl`, tw`mb-2`]}>
          {t('carnet:livret.competenceNumerique')}
        </div>
      )}
      <Competences
        livretEvalId={livretEvalId}
        print={readonly}
        value={value.competencesNumerique || []}
        onChange={comps =>
          handleChange({ ...props.livretEleve, competencesNumerique: comps })
        }
      />
      {readonly && !_isEmpty(props.livretEleve.appreciationNumerique) && (
        <div>
          <div tw="text-muted font-bold">{t('carnet:livret.appreciation')}</div>
          <div tw="whitespace-pre-line">
            {props.livretEleve.appreciationNumerique || ''}
          </div>
        </div>
      )}
      {!readonly && (value.competencesNumerique || []).length > 0 && (
        <FormGroup label={t('carnet:livret.appreciation')} tw="mb-20">
          <Textarea
            tw="-ml-1"
            inputRef={textareaRef as any}
            minRows={1}
            removeHandle={!onChange}
            aria-label="Commentaire général des competences numérique"
            placeholder={t(
              'carnet:livret.generalInformationCompetenceNumeriquePlaceholder',
            )}
            value={value.appreciationNumerique || ''}
            onChange={e =>
              handleChange({
                ...props.livretEleve,
                appreciationNumerique: e.target.value,
              })
            }
          />
        </FormGroup>
      )}
    </div>
  );
}
